/* eslint-disable formatjs/no-literal-string-in-jsx */

'use client';

import type { SaleButtonStatus } from './sale-buy-button';

interface SaleStockProps {
  status: SaleButtonStatus;
  inStock: number;
  totalSupply: number;
}

export const SaleStock = ({ status, inStock, totalSupply }: SaleStockProps) => {
  if (status === 'sold-out') {
    return null;
  }

  return (
    <div className="text-[14px] font-bold leading-[1.3] text-white/60">
      {inStock}/{totalSupply}
    </div>
  );
};
